export class ButtonTypes {
    public static fill = 'fill';
    public static outline = 'outline';
}